<script setup lang="ts">
import { useQuasar } from 'quasar';
import BCard from 'src/shared/components/base/BCard/BCard.vue';
import SettingsChangePasswordForm from 'src/modules/Setting/components/SettingsChangePasswordForm/SettingsChangePasswordForm.vue';
import { useSettingsSecurity } from './useSettingsSecurity';

const $q = useQuasar();
const { changePasswordData, changePassword } = useSettingsSecurity();
// interface Props {
//   // moduleValue: string
// }

// defineProps<Props>()

// defineEmits<{
//   // (event: 'update:moduleValue', payload: string): void
// }>()
</script>

<template>
  <BCard
    size="sm"
    class="rounded-borders-xl"
    :class="$q.dark.isActive ? 'shadow-card-dark' : 'shadow-card bg-white'"
    :dark="$q.dark.isActive"
  >
    <q-inner-loading :showing="false">
      <q-spinner-gears
        size="80px"
        color="primary"
      />
    </q-inner-loading>
    <q-card-section>
      <SettingsChangePasswordForm
        :change-password-data="changePasswordData"
        @change-password="changePassword"
      />
    </q-card-section>
  </BCard>
</template>
